import React, { useState, useEffect } from "react";
import "./index.css";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import patientAvatar from "../avatar.png";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StarRatings from "react-star-ratings";
import TextField from "@mui/material/TextField";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FilePresentOutlinedIcon from "@mui/icons-material/FilePresentOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useFormik } from "formik";
import axios from "axios";
import {
  getToken,
  getUser,
  getUserId,
  getUserLevel,
  getUserName,
} from "../../../auth/authenticate";
import { CircularProgress } from "@mui/material";
import { api } from "services/ApiService";
import { ApiEndpoint, Method } from "config/constants/apiConstants";
// import useUser from "../../../context/user/useUser";
import { Payhere, AccountCategory } from "payhere-js-sdk";

import {
  Customer,
  CurrencyType,
  PayhereCheckout,
  CheckoutParams,
} from "payhere-js-sdk";
import {
  APPOINTMENT_TYPES,
  PAYMENT_CATEGORY,
  USER_TYPES,
} from "constants/constants";
import { APPOINTMENT_PURPOSES } from "constants/constants";
import ErrMsg from "components/notification/ErrMsg";
import useDeedToast from "hook/useDeedToast";
import useUser from "context/user/useUser";
import AuthModal from "components/common/AuthModal/AuthModal";
import { UserType } from "config/constants/common";

const AddAppointment2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useLocation();
  const { settings, userRole } = useUser();
  // const user_id = settings.userId;
  const userId = getUser().userId;
  // const userRole = getUserLevel();
  const [showBookingContinue, setShowBookingContinue] = useState(false);

  const [selectFile, setSelectFile] = useState([]);
  const [selectedFileNames, setSelectedFileNames] = useState([]);

  const doctorId = location.pathname.split("/")[3];
  const [doctorData, setDoctorData] = React.useState();
  const [guardianData, setGuardianData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [patientData, setPatientData] = React.useState(null);
  const [appointment, setAppointment] = React.useState(null);
  const { deedToast } = useDeedToast();
  const [selectedPath, setSelectedPath] = useState(""); // "myself", "existing", "new"

const initializePayhere = () => {
  const env = (process.env.REACT_APP_PAYHERE_ENV || "").trim().toUpperCase();
  const isSandbox = env === "SANDBOX";

  if (isSandbox) {
    Payhere.init(
      process.env.REACT_APP_PAYHERE_SANDBOX_MERCHANT_ID,
      AccountCategory.SANDBOX
    );
  } else {
    Payhere.init(
      process.env.REACT_APP_PAYHERE_MERCHANT_ID,
      AccountCategory.LIVE
    );
  }
};
initializePayhere();

  const url = `${process.env.REACT_APP_BACKEND_URL}payment/create`;
  const urlGuardian = `${process.env.REACT_APP_BACKEND_URL}user/patient/get-patients`;

  useEffect(() => {
    if (state == null) {
      navigate("/doctors");
    }
    fetchDoctorDetails();
    fetchPatientData();
    fetchGuardianData();
    scrollToTop();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  function onPayhereCheckoutError(errorMsg) {
    alert(errorMsg);
  }

  const fetchPatientData = async () => {
    setLoading(true);
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user/patient/profile/`,
      config
    );
    setPatientData(response?.data?.data);
  };

  const fetchGuardianData = async () => {
    setLoading(true);
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const response = await axios.get(urlGuardian, config);
    if (response?.data?.data) {
      // console.log(response?.data?.data);
      setGuardianData(response?.data?.data);
    }
  };

  // console.log('checkout data ============== ::: ');

  async function checkout(values) {
    const customer = new Customer({
      first_name: patientData?.name,
      last_name: patientData?.name,
      phone: patientData?.User?.phoneNumber,
      email: patientData?.User?.email,
      address: patientData?.address,
      city: patientData?.district || "Colombo",
      country: "Sri Lanka",
    });

    // console.log('checkout data ============== ', customer );

    const paymentResponse = await createPayment(
      values.appointmentId,
      doctorData
    );

    // @ts-ignore
    const checkoutData = new CheckoutParams({
      returnUrl: `${process.env.REACT_APP_FRONTEND_BASE_URL}doctor/:id/add-appointments/fill-details/make-payment/thank-you/${values.appointmentId}`,
      cancelUrl: `${process.env.REACT_APP_FRONTEND_BASE_URL}payment/cancel`,
      notifyUrl: `${process.env.REACT_APP_BACKEND_URL}payment/confirmation`,
      order_id: paymentResponse?.data.data.paymentRef,
      itemTitle: PAYMENT_CATEGORY.APPOINTMENT,
      currency: CurrencyType.LKR,
      amount: Math.floor(doctorData?.displayingFee),
      hash: paymentResponse?.data.data.hash,
    });
    const checkout = new PayhereCheckout(
      customer,
      checkoutData,
      onPayhereCheckoutError
    );
    setTimeout(() => {
      checkout.start();
    }, 100);
  }

  async function createPayment(id, doctorData) {
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const payResponse = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}payment`,
      {
        orderRef: id,
        txnAmount: doctorData.displayingFee,
        category: PAYMENT_CATEGORY.APPOINTMENT,
        userId: userId,
        payType: "FP",
      },
      config
    );

    if (payResponse.status == 201) {
      return payResponse;
    } else {
      alert("Payment not created");
      return 0;
    }
  }

  const fetchDoctorDetails = async () => {
    setLoading(true);
    const res = await api(
      ApiEndpoint.GET_DOCTOR_BY_ID + doctorId,
      Method.GET,
      null,
      null
    );
    setDoctorData(res?.data);
    setLoading(false);
  };

  const validateFileType = (file) => {
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/webp",
      "application/pdf",
      "text/plain",
      "application/plain",
      "text/csv",
    ];
    return allowedTypes.includes(file.type);
  };

  const validateFileSize = (file) => {
    const maxSizeBytes = 10 * 1024 * 1024; // 10MB limit
    return file.size <= maxSizeBytes;
  };

  const handleSelectedFile = (event) => {
    const file = event.target.files[0];

    // Validate file type
    if (validateFileType(file)) {
      if (validateFileSize(file)) {
        let selectFiles = [...selectFile];
        let selectFileNames = [...selectedFileNames];
        selectFiles.push(file);
        selectFileNames.push(file.name);
        setSelectFile(selectFiles);
        setSelectedFileNames(selectFileNames);

        // Update Formik form state
        formik.setFieldValue("attachments", selectFiles);

        // Clear previous file error
        formik.setFieldError("attachments", "");
      } else {
        deedToast("file size should be less than 10mb", "danger");
      }
    } else {
      // Set file type error
      deedToast(
        "Invalid file type. Allowed types are: PNG, JPEG, JPG, WebP, PDF, Text",
        "danger"
      );
    }
  };

  const handleRemoveFile = (ind) => {
    const list = [...selectFile];
    const nameList = [...selectedFileNames];
    list.splice(ind, 1);
    nameList.splice(ind, 1);
    setSelectFile(list);
    setSelectedFileNames(nameList);
  };

  const handleSubmit = (values) => {
    setLoading(true);
    try {
      var bodyFormData = new FormData();

      selectFile.forEach((file) => {
        bodyFormData.append("files", file);
      });
      bodyFormData.append("doctorId", doctorId);
      bodyFormData.append("patientId", userId);
      bodyFormData.append("date", state?.date);
      bodyFormData.append("slotTime", new Date(state?.time).toISOString());
      // bodyFormData.append("slotType", state?.slotType);
      bodyFormData.append("appointmentType", values.type);
      bodyFormData.append("purpose", values.purpose);
      bodyFormData.append(
        "medicalDetails",
        values.medicalDetail.length !== 0 ? values.medicalDetail : "  "
      );
      bodyFormData.append("message", values.message);
      if (doctorData) {
        bodyFormData.append("amount", doctorData.displayingFee);
      }

      bodyFormData.append("paymentId", "test_id");
      bodyFormData.append("parentId", userId);

      axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}appointment/patient`,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + getToken(),
        },
      })
        .then(function (response) {
          if (response) {
            setLoading(false);
            deedToast(response.data?.message);
            // navigate("make-payment");
            /*enable redirect payment page =================*/
            checkout(response.data.data);
            setAppointment(response.data.data);
          }
        })
        .catch(function (response) {
          //handle error
          setLoading(false);
          // console.log(response);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const formik = useFormik({
    initialValues: {
      purpose: APPOINTMENT_PURPOSES.CONSULTING,
      medicalDetail: "",
      type: APPOINTMENT_TYPES.ONLINE,
      message: "",
      patient: userId,
      attachments: [],
    },
    validate: (values) => {
      const errors = {};

      // Add validation rules for each required field
      if (!values.purpose) {
        errors.purpose = "Purpose is required";
      }

      if (!values.type) {
        errors.type = "Type is required";
      }

      return errors;
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  if (loading) {
    return (
      <center style={{ marginTop: 200 }}>
        <CircularProgress />
      </center>
    );
  }

  return (
    <>
      <div className="addAppointmentMain">
        <div className="pharmacyInfoMainHeading">
          <div onClick={() => navigate(-1)}>
            <ArrowCircleLeftOutlinedIcon
              className="headingIcon"
              fontSize="large"
            />
          </div>
          <h3>Add Appointment</h3>
        </div>
        <div>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              "& > :not(style)": {
                ml: 2,
                mr: 2,
                pl: 4,
                pb: 2,
                pr: 4,
                width: "100%",
                height: "auto",
                background:
                  "linear-gradient(90.22deg, #0536E3 -19.45%, #00E9ED 142.36%)",
                color: "#ffffff",
              },
            }}
          >
            <Paper elevation={0}>
              <Grid container>
                <Grid item lg={7} md={6} xs={12}>
                  <Stack direction="row" spacing={2}>
                    <Avatar
                      alt="Patient Avatar"
                      src={patientAvatar}
                      className="addAppointmentProfileAvatar"
                    />
                    <div className="addAppointmentProfileAvatarName">
                      <h2>{doctorData && doctorData?.name} </h2>
                      <p>
                        {doctorData?.serviceCategories?.map((item, index) => {
                          if (
                            index ===
                            doctorData?.serviceCategories?.length - 1
                          ) {
                            return <span key={index}> {item} </span>;
                          } else {
                            return <span key={index}> {item} |</span>;
                          }
                        })}
                      </p>
                      <div>
                        <StarRatings
                          rating={4}
                          starDimension="18px"
                          starRatedColor="yellow"
                          numberOfStars={5}
                          starSpacing="1px"
                        />
                      </div>
                    </div>
                  </Stack>
                </Grid>
                <Grid
                  item
                  lg={5}
                  md={6}
                  xs={12}
                  mt={-3}
                  className="appointmentPriceGrid"
                >
                  <p>
                    LKR {doctorData && (doctorData.displayingFee ?? "700")}
                    {".00"}
                  </p>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </div>

        <div className="docterProfileScroll">
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              "& > :not(style)": {
                ml: 2,
                mr: 2,
                pl: 4,
                pb: 2,
                pr: 4,
                width: "100%",
                height: "auto",
              },
            }}
          >
            {/* info1 info2 edit icon css from doctor profile component */}
            <Paper elevation={0}></Paper>
          </Box>
        </div>
      </div>
    </>
  );
};
export default AddAppointment2;
